export enum StorefrontAuthenticationWorkspaceCapabilityAccessOperation {
    create = "9f06f9c9-ba64-442e-8602-9388c685b4fd",
    read = "89e97c04-98cd-4c61-bb1a-a07632f1d670",
    update = "2d2e1794-526f-4f62-af08-27996e1a5971",
    delete = "910ecf60-7240-4f0a-a08e-4916499e49f0",
}
